import type { ReactNode } from 'react';

import { Flex, Typography } from 'antd';

import { formatMetricValue } from '@/shared/lib/utils';

const { Text } = Typography;

export type QualityStatusItem = {
  icon: ReactNode;
  count: number;
  ratio: number;
};

type QualityStatusIndicatorProps = {
  items: QualityStatusItem[];
};

export const QualityStatusIndicator = ({ items }: QualityStatusIndicatorProps) => {
  return (
    <Flex vertical gap={4}>
      {items.map((item, index) => (
        <Flex key={index} align="center" gap={8}>
          {item.icon}
          <Text>
            {formatMetricValue(item.count)} ({formatMetricValue(item.ratio * 100)}%)
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};
